<immo-swiper theme="menu" [options]="menuOptions">
  <button slot="button-prev" class="ml-3" immoIconButton icon="caret-left" size="xs" type="button" outlined theme="surface-container-low"></button>
  <button slot="button-next" class="mr-3" immoIconButton icon="caret-right" size="xs" type="button" outlined theme="surface-container-low"></button>

  @for (item of navigation(); track $index) {
    <ng-template immoSwiperSlide>
      <immo-navigation-item [item]="item" [isExpanded]="true" [withIcon]="false" />
    </ng-template>
  }
</immo-swiper>
